import { Injectable } from '@angular/core';
import { CanActivate, Route, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from '../auth/services/oidc.security.service';
import { AuthWellKnownEndpoints } from '../auth/services/auth.well-known-endpoints';
import { Subscription } from 'rxjs/Subscription';
import { AuthorizedStatusService } from '../services/authorized-status.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IsAuthenticatedGuard implements CanActivate {

    private isAuthenticated: Observable<boolean>;

    constructor(private router: Router, private oidcSecurityService: OidcSecurityService, private wellKnownEndpoints: AuthWellKnownEndpoints, private _authStatus: AuthorizedStatusService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        //this.isAuthorizedSubscription = this.oidcSecurityService.getIsAuthorized().subscribe(
        //    (isAuthorized: boolean) => {
        //        this.isAuthenticated = isAuthorized;
        //    });

        //console.log(this._authStatus.isAuthorized());

        //if (!this._authStatus.isAuthorized()) {
        //    if (this.wellKnownEndpoints.endPointsLoaded) {
        //        this.oidcSecurityService.authorize();
        //    } else {
        //        this.wellKnownEndpoints.onWellKnownEndpointsLoaded.subscribe(() => {
        //            this.oidcSecurityService.authorize();
        //        });
        //    }
        //}
        //this.router.navigate(['']);
        return this.oidcSecurityService.getIsAuthorized();
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/guards/isAuthenticatedGuard.ts